// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function OutcomesSection() {
  const { t } = useTranslation('servicesTestEquipmentModernization')

  const items = [
    t('outcomes.items.01'),
    t('outcomes.items.02'),
    t('outcomes.items.03'),
    t('outcomes.items.04'),
    t('outcomes.items.05'),
    t('outcomes.items.06'),
    t('outcomes.items.07'),
    t('outcomes.items.08'),
    t('outcomes.items.09'),
    t('outcomes.items.10'),
    t('outcomes.items.11'),
    t('outcomes.items.12')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('outcomes.eyebrow')}
        title={t('outcomes.title')}
        intro={[t('outcomes.intro')]}
      />

      <BulletGrid items={items} columns={3} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
